import { Method, send } from '../../lib/MyHttp';

/**
 * 정보
 */
export const Get = (component, success, fail) => {
    const params = {};
    send(component, Method.GET, '/a/config', params, success, fail);
};

/**
 * 등록
 */
export const Create = (component, params, success, fail) => {
    const paramsT = {
        ...params,
    };

    delete paramsT.id;
    delete paramsT.createdAt;
    delete paramsT.updatedAt;

    send(component, Method.POST, '/a/config/', paramsT, success, fail);
};
